module.exports = __webpack_public_path__ + "img/booking2.f177816e.svg";